import { render, staticRenderFns } from "./Futures.vue?vue&type=template&id=0cf3f2b0&"
import script from "./Futures.vue?vue&type=script&lang=js&"
export * from "./Futures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports